import { createGlobalStyle } from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const GlobalWhiteBackground = createGlobalStyle`
  html, body {
    background-color: ${FullPalette.WHITE};

    #subheader, #large-wrapper {
      background-color: ${FullPalette.WHITE};
    }
  }
`;

export const GlobalWhiteBackgroundImportant = createGlobalStyle`
  body {
    background-color: ${FullPalette.WHITE} !important;

    #subheader, #large-wrapper {
      background-color: ${FullPalette.WHITE} !important;
    }
  }
`;

export default GlobalWhiteBackground;
